import {MainBannerComponent} from './MainBannerComponent';
import {BannerComponent} from './BannerComponent';
import {BlockQuoteComponent} from './BlockQuoteComponent';
import {TextComponent} from './TextComponent';
import {ContactDetailsComponent} from './ContactDetailsComponent';
import {ServicesIconsComponent} from './ServicesIconsComponent';
import {ServicesDescriptionComponent} from './ServicesDescriptionComponent';
import {ServicesBulletedComponent} from './ServicesBulletedComponent';
import {MemberComponent} from './MemberComponent';
import {SliderComponent} from './SliderComponent';
import {ServicesBlockComponent} from './ServicesBlockComponent';
import ContactFormComponent from './ContactFormComponent';
import {TextMediaComponent} from './TextMediaComponent';
import {CorporateBannerComponent} from './CorporateBannerComponent';
import {CorporateInfoComponent} from './CorporateInfoComponent';
import {CorporateContactDetails} from './CorporateContactDetails';
import {CorporateTeam} from './CorporateTeam';

export {
  BannerComponent,
  BlockQuoteComponent,
  ContactDetailsComponent,
  ServicesIconsComponent,
  ServicesDescriptionComponent,
  ServicesBulletedComponent,
  MemberComponent,
  MainBannerComponent,
  ServicesBlockComponent,
  SliderComponent,
  TextComponent,
  ContactFormComponent,
  TextMediaComponent,
  CorporateBannerComponent,
  CorporateInfoComponent,
  CorporateContactDetails,
  CorporateTeam
}



// WEBPACK FOOTER //
// src/client/components/common/CMS/components/index.js